@let payment = $payment | async;
<div class="container">
  <mat-card>
    <mat-card-content>
      @if (payment) {
      <display-input
        title="netCashPaymentId"
        [value]="payment.netCashPaymentId"
      />
      <display-input title="batchName" [value]="payment.batchName" />
      <display-input title="instruction" [value]="payment.instruction" />
      <display-input title="total" [value]="payment.total.toString()" />
      <display-input title="status" [value]="payment.status" />
      } @if (error) {
      <app-alert (close)="error=null" class="mt-3" type="error">
        {{error}}
      </app-alert>
      } @if (!($paymentsFetchedAt | async)) {
      <mat-spinner></mat-spinner>
      }
    </mat-card-content>
  </mat-card>
</div>

@if (payment) {
<div class="container mt-5">
  <p>Transactions:</p>

  <table mat-table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
      <td mat-cell *matCellDef="let element">{{ element?.id || "N/A" }}</td>
    </ng-container>

    <ng-container matColumnDef="statementId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Statement Id</th>
      <td mat-cell *matCellDef="let element">
        {{ element.statementId || "N/A" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
      <td mat-cell *matCellDef="let element">
        {{ element.amount | currency : "R" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <div class="centered-vertically">
          <mat-icon [ngClass]="isPaid(element) ? 'green' : 'red'">
            {{isPaid(element) ? 'check_circle' : 'cancel'}}
          </mat-icon>
          <span class="small-light-grey">
            {{ this.getStatusText(element) }}
          </span>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columns"
      (click)="navToTransactionDetails(row.id)"
    ></tr>

    <tr *matNoDataRow>
      <td colspan="4">
        <div class="no-data-message">No payments found.</div>
      </td>
    </tr>
  </table>
</div>
}
